import React, { useCallback, useContext } from 'react'
import { ParentContext } from '../ParentContext';
import { dataFix } from 'global/common/dataFix';
import { DatabaseContext } from '../DatabaseContext';
import { _appSettingsCollectionName } from 'global/cnr/reducers/BaseSettingsReducer';
import { serverTimestamp } from 'firebase/firestore';
import { createRefPath } from 'global/firestoreData/appData/appRefPaths';
import { _settingsFs } from 'global/viewSettings/actions/getSettings';

export const useBaseSettingsData = () => {

  const parentContext = useContext(ParentContext);
  const { fn_cls } = parentContext ?? {}

  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  console.log('fn_cls', fn_cls)

  const getAppSettingsFromFunctions = useCallback(async ({ appUserAccess, logging, callback }) => {
    const cb = (settings) => {
      console.log('settings', settings)
      callback(settings)
    }
    const vvProps = { appUserAccess }
    // get the base settings from firebase functions 
    const y = fn_cls.getAppSettings(vvProps, logging)
    y.then(settings => { cb(settings) })
  }, [])

  const handleUpdateAppSettings = useCallback(async ({ settings, aua, callback }) => {
    if (settings) {
      const _settings = dataFix.removeAllEmpties(settings)
      console.log('saveBaseSettingsToAppSettings >>', _settings)
      appSettingsPromise(database_fns, _settings, aua).then(res => {
        console.log('saveBaseSettingsToAppSettings DONE')
        callback({ type: dispatchProps.success })
      }).catch(error => {
        console.log('error!!!!!!!!!!!!!!!!', error)
      })
    }
  }, [])

  const updateAdjustedPermission = useCallback(async ({ consoleKey, consoleGroup, callback }) => {
    const _refVw = createRefPath([_appSettingsCollectionName, 'app', _settingsFs.collection, 'adjustedPermissions'])
    const dataToUpdate = {
      [consoleKey]: consoleGroup
    }
    database_fns.set_doc(_refVw, dataToUpdate, true, callback)
  }, [])

  return { getAppSettingsFromFunctions, updateAdjustedPermission, handleUpdateAppSettings }
}



const appSettingsPromise = async (database_fns, settings, aua) => {

  const promises = []

  const _ref = createRefPath([_appSettingsCollectionName, 'app'])

  const _appData = {
    _updateDate: serverTimestamp(),
    ...aua,
  }
  promises.push(database_fns.set_doc(_ref, _appData, true)
  )
  Object.keys(settings).forEach(sk => {
    const setting = settings[sk]
    const _docRef = createRefPath([_appSettingsCollectionName, 'app', _settingsFs.collection, sk])
    promises.push(database_fns.set_doc(_docRef, setting, false))
  })
  return Promise.all(promises)
}